import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "ml-auto" }
const _hoisted_2 = ["onClick", "textContent"]
const _hoisted_3 = ["textContent"]
const _hoisted_4 = ["textContent"]

import { onMounted, ref } from 'vue';
import Column from 'primevue/column';
import DataTable from 'primevue/datatable';
import { useToast } from 'primevue/usetoast';
import { useDocumentsStore } from '@/store';
import { useDateTime, can } from '@/composables';
import AddDocumentModal from '@/components/UploadModal/AddDocumentModal.vue';
import { PERMISSIONS } from '@/enum';


export default /*@__PURE__*/_defineComponent({
  __name: 'Documents',
  setup(__props) {

const toast = useToast();
const documentStore = useDocumentsStore();
const documentModalOpen = ref(false);

onMounted(() => getDocuments());

const getDocuments = async () => {
  if (can([PERMISSIONS.PERSON_DOCUMENTS_INDEX])) await documentStore.getDocuments();
  else doFailUnauthorized('view');
};

const openDocumentUploader = () => (documentModalOpen.value = true);

const doToast = (summary: string, detail: string) => {
  toast.add({
    severity: 'success',
    summary,
    detail,
    life: 3000,
  });
};

const doFailUnauthorized = (action: string) => {
  toast.add({
    severity: 'error',
    summary: 'Error',
    detail: `User unauthorized to ${action} documents.`,
    life: 5000,
  });
};

const onSaveAdd = () => {
  if (can([PERMISSIONS.PERSON_DOCUMENTS_STORE])) {
    getDocuments();
    doToast('Added', 'New Document has been added');
  } else {
    doFailUnauthorized('upload');
  }
};

const onCancelAdd = () => (documentModalOpen.value = false);

const onDeleteDocument: (id: number) => Promise<void> = async (id) => {
  if (can([PERMISSIONS.DOCUMENTS_DESTROY])) {
    await documentStore.deleteDocument(id);
    getDocuments();
    doToast('Removed', 'Document has been removed');
  } else {
    doFailUnauthorized('delete');
  }
};

const onDownloadDocument = (id: number, name: string) => {
  if (can([PERMISSIONS.DOCUMENTS_DOWNLOAD])) {
    documentStore.downloadDocument(id, name);
    doToast('Downloaded', 'Document successfully downloaded');
  } else {
    doFailUnauthorized('download');
  }
};

return (_ctx: any,_cache: any) => {
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock(_component_Card, null, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_unref(can)([_unref(PERMISSIONS).PERSON_DOCUMENTS_STORE]))
          ? (_openBlock(), _createBlock(_component_AppButton, {
              key: 0,
              type: "primary",
              text: "Upload Document",
              "icon-left": "cloud-upload",
              onClick: openDocumentUploader
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    content: _withCtx(() => [
      _createVNode(_unref(DataTable), {
        value: _unref(documentStore).documents,
        scrollable: true,
        "loading-icon": "logo-spinner",
        loading: _unref(documentStore).loading,
        "responsive-layout": "scroll",
        "scroll-height": "440px"
      }, {
        empty: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createTextVNode("No documents", -1)
        ]))]),
        default: _withCtx(() => [
          (_unref(documentStore).documents.length)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createVNode(_unref(Column), {
                  field: "title",
                  header: "Title",
                  "header-style": "color: #3B4242;"
                }, {
                  body: _withCtx(({ data }) => [
                    _createElementVNode("span", {
                      class: "download cursor-pointer",
                      onClick: ($event: any) => (onDownloadDocument(data.id, data.name)),
                      textContent: _toDisplayString(data.name)
                    }, null, 8, _hoisted_2)
                  ]),
                  _: 1
                }),
                _createVNode(_unref(Column), {
                  field: "description",
                  header: "Description",
                  "header-class": "justify-content-center",
                  "body-class": "justify-content-center text-align-center",
                  "body-style": "font-size: .8725rem;"
                }, {
                  body: _withCtx(({ data }) => [
                    _createElementVNode("span", {
                      textContent: _toDisplayString(data.description)
                    }, null, 8, _hoisted_3)
                  ]),
                  _: 1
                }),
                _createVNode(_unref(Column), {
                  field: "created_at",
                  header: "Date Created",
                  "header-class": "justify-content-center",
                  "body-class": "justify-content-center",
                  "body-style": "font-size: .8725rem;"
                }, {
                  body: _withCtx(({ data }) => [
                    _createElementVNode("span", {
                      textContent: _toDisplayString(_unref(useDateTime)().formatIntlDate(data.created_at))
                    }, null, 8, _hoisted_4)
                  ]),
                  _: 1
                }),
                _createVNode(_unref(Column), {
                  "body-class": "justify-content-center",
                  "body-style": "font-size: .8725rem;",
                  "header-class": "justify-content-center",
                  header: "Actions"
                }, {
                  body: _withCtx(({ data }) => [
                    (_unref(can)([_unref(PERMISSIONS).DOCUMENTS_DOWNLOAD]))
                      ? (_openBlock(), _createBlock(_component_AppButton, {
                          key: 0,
                          type: "text",
                          size: "large",
                          "icon-left": "cloud_download",
                          class: "text-600 cloud-download",
                          onClick: ($event: any) => (onDownloadDocument(data.id, data.name))
                        }, null, 8, ["onClick"]))
                      : _createCommentVNode("", true),
                    (_unref(can)([_unref(PERMISSIONS).DOCUMENTS_DESTROY]))
                      ? (_openBlock(), _createBlock(_component_AppButton, {
                          key: 1,
                          type: "text",
                          size: "large",
                          "icon-left": "delete",
                          class: "text-600",
                          onClick: ($event: any) => (onDeleteDocument(data.id))
                        }, null, 8, ["onClick"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ], 64))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["value", "loading"]),
      (documentModalOpen.value && _unref(can)([_unref(PERMISSIONS).PERSON_DOCUMENTS_STORE]))
        ? (_openBlock(), _createBlock(AddDocumentModal, {
            key: 0,
            title: "Upload Document",
            onCancel: onCancelAdd,
            onSave: onSaveAdd
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})